import React, { useEffect, useState } from 'react';
import { Multiselect } from 'multiselect-react-dropdown';
import {
	UseFormRegister,
	UseFormSetValue,
	UseFormClearErrors,
} from 'react-hook-form';

import './MultiSelect.sass';

import IInputs from '../../../interfaces/IInputs';
import IRules from '../../../interfaces/IRules';

import TooltipIcon from '../TooltipIcon';

interface Props {
	options: [];
	placeholder?: string;
	inputName:
		| 'talkTrack'
		| 'talkTrack2'
		| 'talkTrack3'
		| 'talkAudienceLevel'
		| 'talkAudienceLevel2'
		| 'talkAudienceLevel3';
	hasTooltip?: string;
	required?: boolean;
	label: string;
	rules: IRules;
	register: UseFormRegister<IInputs>;
	setValue: UseFormSetValue<IInputs>;
	clearErrors: UseFormClearErrors<IInputs>;
	isFormSubmitted: boolean;
}

function MultiSelect({
	options,
	placeholder,
	inputName,
	hasTooltip,
	required,
	label,
	register,
	setValue,
	clearErrors,
	rules,
	isFormSubmitted,
}: Props) {
	const [selectedValues, setSelectedValues] = useState<[]>([]);
	useEffect(() => {
		setSelectedValues([]);
	}, [isFormSubmitted]);

	const handleChange = (opt: []) => {
		setValue(inputName, opt.join());
		setSelectedValues([...opt]);
	};
	const onSelect = (selectedList: [], selectedItem: string) => {
		handleChange(selectedList);
	};

	const onRemove = (selectedList: [], removedItem: string) => {
		handleChange(selectedList);
	};

	return (
		<div className="select-row">
			<label htmlFor={inputName} className="form-label">
				{label} {required && '*'}
				{hasTooltip && hasTooltip !== '' && (
					<TooltipIcon tooltipValue={hasTooltip} />
				)}
			</label>
			<div className="multi-select">
				<Multiselect
					onSelect={(selectedList: [], selectedItem: string) =>
						onSelect(selectedList, selectedItem)
					}
					onRemove={(selectedList: [], removedItem: string) =>
						onRemove(selectedList, removedItem)
					}
					{...register(inputName, rules)}
					id={inputName}
					options={options}
					isObject={false}
					placeholder={placeholder}
					selectionLimit="2"
					selectedValues={[...selectedValues]}
				/>
			</div>
		</div>
	);
}

MultiSelect.defaultProps = {
	hasTooltip: false,
	required: false,
	placeholder: '',
};

export default MultiSelect;
